// extracted by mini-css-extract-plugin
module.exports = {"fade":"Animation_fade__3mAdT","fadeOn":"Animation_fadeOn__2Ll0L","fadeOn3":"Animation_fadeOn3__3Olwr","fadeOn6":"Animation_fadeOn6__2JU5h"};